import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { endRouteLoading } from 'actions/SideNav';
import HomeView from 'components/Home/HomeView';
import actions from 'actions/FullScreenModal';
import { START_CALL_MODAL } from 'constants/StartCallModal';
import { accountSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';

function mapDispatchToProps(dispatch) {
  return {
    endRouteLoading: () => {
      dispatch(endRouteLoading());
    },
    openStartCallModal: () => {
      dispatch(actions.openFullScreenModal(START_CALL_MODAL));
    }
  };
}

const mapStateToProps = (state, ownProps) => {
  const accountSettings = accountSelectors.getAccountSettings(state);
  return {
    ...ownProps,
    recordingsUrl: _get(accountSettings, 'recordingEnabled') ? _get(accountSettings, 'recordingUrl') : ''
  };
};

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(HomeView);

const FunctionalWrapper = (props) => {
  const isCallConnected = hooks.useCallConnected();
  return <ConnectedComponent isCallConnected={isCallConnected} {...props} />;
};
export { ConnectedComponent as HomeContainer };
export default FunctionalWrapper;
